export const VISIBILITY_MODES = {
  UPPER_LOWER: "upper_lower",
  UPPER: "upper",
  LOWER: "lower",
};

export const VIEWS = {
  DEFAULT: "DEFAULT",
  DIFF: "DIFF",
  HEMIAN: "HEMIAN",
};

export const sharedData = {
  isCompressed: false,
  plyFiles: {
    gums: [],
    teeth: [],
    attachments: [],
  },
  areFilesLoaded: false,
  modelsObjectCache: [],
  currentView: VIEWS.DEFAULT,
  isGridVisible: false,
};
